import React from 'react'
import {connect} from 'react-redux'
import { Route, Redirect } from 'react-router-dom';
import {withRouter} from "react-router-dom";

import * as actions from '../../actions'

class Auth extends React.Component {

  componentWillMount() {
    this.props.handleFetchUser();
  }

  render() {
    switch(this.props.auth.loginState) {
      case 0:
      case 1:
        return (<Route children={this.props.children} />)
      case 9:
      default:
        return (<Redirect to={'/login'} />)
    }
  }

}

const mapStateToProps = (state) => ({
  auth: state.auth
})

const mapStateToDispatch = (dispatch) => ({
  handleFetchUser: () => {dispatch(actions.systemFetchLoginState())}
})

Auth = withRouter(Auth);

Auth = connect(
  mapStateToProps,
  mapStateToDispatch
)(Auth)

export default Auth


// WEBPACK FOOTER //
// ./src/containers/auth/Auth.js